import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ec44b6ec&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec44b6ec')) {
      api.createRecord('ec44b6ec', component.options)
    } else {
      api.reload('ec44b6ec', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=ec44b6ec&", function () {
      api.rerender('ec44b6ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notice/push/index.vue"
export default component.exports